// This file contains version information for the application
// It is dynamically generated during the build process
export const VERSION_INFO = {
  appName: "RNR Mobile",
  planLevel: "Freemium",
  version: "v1.0.1",
  commitHash: "b77ea68",
  buildDate: "05 November 2026"
};
